module.exports = __webpack_public_path__ + "static/media/avail.acfb2afd.png";